import store from '@/store'
import base from '@/__vue2stone/service/wasaapi/v1/__base'

export default {
  async index(params) {
    const factoryId = store.state.app.factory.id;
    const _params = {
      factory: factoryId,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'i18n',
      params: _params,
    });
    return res;
  },
}